import { useFormikContext, getIn } from 'formik'
import OrganisationField from 'Shared/components/OrganisationField'
import FormikSelect from 'Shared/components/FormikSelect/FormikSelect'
import Button from 'Shared/components/Button'
import './RoleRow.scoped.scss'

const UserRole = ({
    index,
    values,
    setFieldValue,
    roles,
    roleIdsCanInvite,
    isEditingSelf,
    onRemove,
}) => {
    const assignment = values.roleAssignments[index]
    const locked = assignment.locked && isEditingSelf
    const cannotMoveOrganisation = assignment.cannotMoveOrganisation
    const canInvite = (roleId) => roleIdsCanInvite?.includes?.(roleId)
    const options = roles
        .map((r) => ({ value: r.id, label: r.name }))
        .filter((o) => canInvite(o.value) || o.value === assignment.roleId)
    const { errors, touched, submitCount, setFieldTouched } = useFormikContext()
    const orgPath = `roleAssignments[${index}].organisationId`
    const orgErr = getIn(errors, orgPath)
    const orgTouched = getIn(touched, orgPath)
    const showOrgErr = !!orgErr && (orgTouched || submitCount > 0)

    return (
        <div className="role-row">
            <OrganisationField
                value={assignment.organisationId}
                setFieldValue={(name, value) =>
                    setFieldValue(`roleAssignments[${index}].organisationId`, value)
                }
                disabled={locked || cannotMoveOrganisation}
                allowBlank={true}
                slim
                useSelect
            />
            {showOrgErr && (
                <div className="error-message bold red margin-bottom">
                    {orgErr}
                </div>
            )}
            {cannotMoveOrganisation &&
                <div className="error-message bold red margin-bottom">
                    You can't move this role to another organisation, as it contains permissions only relevant to your national organisation.
                </div>
            }

            <FormikSelect
                name={`roleAssignments[${index}].roleId`}
                classNamePrefix="roles-select"
                options={options}
                isMulti={false}
                isDisabled={locked}
            />

            {!locked && <div className='margin-top'>
                <Button red small onClick={onRemove}>
                    Remove
                </Button></div>}
        </div>
    )
}

export default UserRole